import { render, staticRenderFns } from "./BoxInspectionsTableDetails.vue?vue&type=template&id=52690ced&scoped=true"
import script from "./BoxInspectionsTableDetails.vue?vue&type=script&lang=js"
export * from "./BoxInspectionsTableDetails.vue?vue&type=script&lang=js"
import style0 from "./BoxInspectionsTableDetails.vue?vue&type=style&index=0&id=52690ced&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52690ced",
  null
  
)

export default component.exports